/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCoinListRequest = {
    sortField?: AptosCoinListRequest.sortField;
    sortDirection?: AptosCoinListRequest.sortDirection;
    type?: AptosCoinListRequest.type;
    page?: number;
    size?: number;
};

export namespace AptosCoinListRequest {

    export enum sortField {
        NAME = 'NAME',
        PRICE = 'PRICE',
        PRICE_CHANGE = 'PRICE_CHANGE',
        MARKET_CAP = 'MARKET_CAP',
        FDV = 'FDV',
        VOLUME = 'VOLUME',
        VOLUME_CHANGE = 'VOLUME_CHANGE',
        HOLDER = 'HOLDER',
        HOLDER_CHANGE = 'HOLDER_CHANGE',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum type {
        ALL = 'ALL',
        COIN = 'COIN',
        FUNGIBLE_ASSET = 'FUNGIBLE_ASSET',
    }


}

